import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

const STALE_TIME = 10000; // 10 seconds

export const useProjectCounters = (projectId, config = {}) =>
  useQuery({
    staleTime: STALE_TIME,
    ...config,
    queryKey: ["project-counters", projectId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/counters`,
        signal,
      }),
  });
